// import i18next from 'i18next';
// import I18NextVue from 'i18next-vue';
// import { VueQueryPlugin } from '@tanstack/vue-query';
import { initiateVueIslands } from '@/composition/semantic-html/use-semantic-html-to-vue';
import Vue3TouchEvents from "vue3-touch-events";

// import '@/style/main.scss';
// import '@/composition/scroll-to-element';
// const LANGUAGE = document.documentElement.lang || 'nl';

initiateVueIslands(document, async (app) => {
  app.use(Vue3TouchEvents);
  // await i18next.init({ lng: LANGUAGE, fallbackLng: 'nl' });
  // app.use(I18NextVue, { i18next }).use(VueQueryPlugin);
});
